import { Paragraph } from '@sentara-health/optimahealth_web';
import { useTranslation } from 'react-i18next';

const GuestDefault = () => {
  const { t } = useTranslation();

  return (
    <div className="black-color py-4">
      <Paragraph
        text={t('profile.designatedRepresentative.accountSharedDescription2')}
        variant="regular"
        className="mb-0"
      />
    </div>
  );
};

export default GuestDefault;
